import { createStore, useStore } from "vuex"
import { useRoute } from "vue-router"
import alovaInstance from "../utils/alova"

// 从localStorage加载状态
const loadState = () => {
  try {
    const serializedState = localStorage.getItem("teacherState")
    if (serializedState === null) return undefined
    return JSON.parse(serializedState)
  } catch (err) {
    return undefined
  }
}

// 保存状态到localStorage
const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state)
    localStorage.setItem("teacherState", serializedState)
  } catch (err) {
    // 错误处理
  }
}

const store = createStore({
  state() {
    return {
      currentStudent: loadState()?.currentStudent || null,
      currentClass: loadState()?.currentClass || null,
      lessonId: loadState()?.lessonId || -1,
      lessonName: loadState()?.lessonName || "课堂",
      lessonUrl: loadState()?.lessonUrl || "",
      courseId: loadState()?.courseId || -1,
      courseName: loadState()?.courseName || "",
    }
  },
  getters: {
    getCurrentStudent(state) {
      return state.currentStudent
    },
    getCurrentClass(state) {
      return state.currentClass
    },
    getLessonId(state) {
      let route = useRoute()
      if (!route.query.lessonId || route.query.lessonId != state.lessonId) {
        fetchLessonData(state, route.query.lessonId)
      }
      return state.lessonId
    },
    getLessonName(state) {
      let route = useRoute()
      if (!route.query.lessonId || route.query.lessonId != state.lessonId) {
        fetchLessonData(state, route.query.lessonId)
      }
      return state.lessonName
    },
    getLessonUrl(state) {
      let route = useRoute()
      if (!route.query.lessonId || route.query.lessonId != state.lessonId) {
        fetchLessonData(state, route.query.lessonId)
      }
      return state.lessonUrl
    },
    getCourseName: (state) => (id) => {
      if (id != state.courseId) 
        return ""
      return state.courseName
    },
  },
  mutations: {
    setCurrentStudent(state, student) {
      state.currentStudent = student
    },
    setCurrentClass(state, classInfo) {
      state.currentClass = classInfo
    },
    setLessonId(state, id) {
      state.lessonId = id
    },
    setLessonName(state, name) {
      state.lessonName = name
    },
    setLessonUrl(state, url) {
      state.lessonUrl = url
    },
    setCourseId(state, id) {
      state.courseId = id
    },
    setCourseName(state, name) {
      state.courseName = name
    },
  },
  actions: {
    setCurrentStudent({ commit }, student) {
      commit("setCurrentStudent", student)
    },
    setCurrentClass({ commit }, classInfo) {
      commit("setCurrentClass", classInfo)
    },
    setLessonId({ commit }, id) {
      commit("setLessonId", id)
    },
    setLessonName({ commit }, name) {
      commit("setLessonName", name)
    },
    setLessonUrl({ commit }, url) {
      commit("setLessonUrl", url)
    },
    setCourseBase({ commit }, info) {
      commit("setCourseId", info.courseId)
      commit("setCourseName", info.courseName)
    },
  },
})

const fetchLessonData = async (state, lessonId) => {
  const store = useStore()
  if (state.lessonId === lessonId) {
    return {
      lessonId: state.lessonId,
      lessonName: state.lessonName,
      lessonUrl: state.lessonUrl,
    }
  }

  try {
    const response = await alovaInstance.Post(`/Record/GetLessonDetailInfo`, {
      lessonId: lessonId,
    })
    if (response.code !== 1000 || response.data === null) {
      store.dispatch("setLessonId", lessonId)
      store.dispatch("setLessonName", "")
      store.dispatch("setLessonUrl", "")
      alert("获取课堂信息失败")
      return
    }

    const lessonData = response.data
    store.dispatch("setLessonId", lessonId)
    store.dispatch(
      "setLessonName",
      "课堂" + lessonData.serial_no + "：" + lessonData.lesson_name
    )
    store.dispatch("setLessonUrl", lessonData.url)

    return lessonData
  } catch (error) {
    console.error("Failed to fetch lesson data:", error)
    throw error
  }
}

// 订阅mutations，自动保存状态
store.subscribe((mutation, state) => {
  saveState(state)
})

export default store
